module.exports = __webpack_public_path__ + "img/section-1_bottom_img_sustainability.eeb4c70b.png";